import React from "react";

import Formatters from "../../shared/utils/Formatters";

export default function AmortizingSchedule({
  loanStartDate,
  paymentSchedules
}){
  
  function scheduleList(){
    return paymentSchedules.map((paymentSchedule, index)=>{
      return (
        <div
          key={index}
          className="_displayFlex _justifyContent-space-between _marginBottom--small _horizontalPadding--xlarge-tabletUp"
        >
          <strong
            className="byline -darkBlue"
            data-testid={"amortizing-schedule-date-" + index}
          >
            <span className="ds-tag _marginRight--xsmall _borderRadius--medium">
              {index + 1}
            </span>
            {Formatters.date(paymentSchedule.due_date)}
          </strong>
          <strong
            className="-primary"
            data-testid={"amortizing-schedule-value-" + index}
          >
            {Formatters.currencyDecimal(paymentSchedule.total)}
          </strong>
        </div>
      );
    })
  }

  function loanTermLabel(){
    const lastSchedule = paymentSchedules[paymentSchedules.length - 1];
    return (
      <strong className='byline -darkBlue' data-testid='loan-term-label'>
        Loan Term:{' '}
        {`${Formatters.date(loanStartDate)} - ${Formatters.date(
          lastSchedule.due_date
        )}`}
      </strong>
    );
  }

  return (
    <section className='cardSection __horizontalPadding--large'>
      <p className='subhead -darkBlue'> Your payment schedule <sup>1</sup> </p>
      {loanTermLabel()}
      <div className='_displayFlex _justifyContent-space-between _marginBottom--small _horizontalPadding--xlarge'>
        <span className='bit -darkBlue'>DUE DATE</span>
        <span className='bit -darkBlue'>PAYMENT AMOUNT</span>
      </div>
      {scheduleList()}
    </section>
  );
}






// WEBPACK FOOTER //
// ./src/features/loans/components/AmortizingSchedule.js